import { useState } from 'react';
import { useSelector } from 'react-redux';

import CustomCard from '../customs/CustomCard';
import TabSlider from '../customs/TableSelector';
import AccessManagement from './AccessManagement';
import AdminControls from '../components/admin/AdminControls';


function AdminPage() {
  const { userData } = useSelector((state) => state.auth);
  const [activeIndex, setActiveIndex] = useState(0);

  if (userData?.role !== 'admin') {
    return null;
  }

  return (
    <CustomCard style={{ margin: 20 }}>
      <div style={{ width: '100%', justifyItems: 'center', marginBottom: 30 }}>
        <TabSlider
          subcategories={['Admin Panel', 'Access Management']}
          setOnlyIndex
          subCatOnClick={setActiveIndex}
          style={{ background: '#FFF' }}
          TextStyle={{ padding: '6px 120px' }}
        />
      </div>

      {activeIndex === 0 ? <AdminControls /> : <AccessManagement />}
    </CustomCard>
  );
}


export default AdminPage;
